module.exports = __webpack_public_path__ + "static/media/caio.92490066.jpg";